<template>
  <v-app>
    <!-- <v-dialog v-model="isIdle" width="60%"> -->
    <!-- <v-card v-if="isIdle">
        <v-card-title
          class="headline font-weight-regular blue-grey white--text"
          primary-title
        >
          Session Expired
        </v-card-title>

        <v-divider></v-divider> -->

    <ModalIdle v-if="isIdle"></ModalIdle>
    <LicenseExpiredModal
        v-model="licenseExpiredVisible"
        :message="licenseExpiredMessage"
    />
    <!-- </v-card> -->
    <!-- </v-dialog> -->
    <router-view/>
  </v-app>
</template>

<script>
import ModalIdle from "../src/sharedComponents/ModalIdle";
import LicenseExpiredModal from "../src/sharedComponents/LicenseExpiredModal";
import {LOGOUT} from "@/store/actions.type";
import {eventBus} from "@/common/eventBus";
import {setLicenseExpiredActive} from "@/common/licenseExpiredState";

export default {
  name: "App",
  components: {
    ModalIdle,
    LicenseExpiredModal,
  },
  data() {
    return {
      licenseExpiredVisible: false,
      licenseExpiredMessage: "License expired. Please renew license to use the functionality.",
    };
  },
  computed: {
    isIdle() {
      return this.$store.state.idleVue.isIdle;
    },
  },
  created() {
    const token = localStorage.getItem("token");
    const expirationTimeRaw = localStorage.getItem("expirationTime");
    const expirationTime = expirationTimeRaw ? Number(expirationTimeRaw) : null;
    const isExpired = expirationTime == null || Number.isNaN(expirationTime) || Date.now() > expirationTime;
    if (token && isExpired) {
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      this.logout();
    }
    eventBus.$on("license-expired", (message) => {
      this.licenseExpiredMessage = message || this.licenseExpiredMessage;
      this.licenseExpiredVisible = true;
    });
  },
  watch: {
    licenseExpiredVisible(val) {
      if (!val) {
        setLicenseExpiredActive(false);
      }
    },
  },
  beforeDestroy() {
    eventBus.$off("license-expired");
  },
  methods: {
    logout() {
      this.$store.dispatch(LOGOUT).then(() => {
        localStorage.removeItem("token");
        localStorage.removeItem("user");
        this.$router.push("/login");
      });
    },
  },


};
</script>
